import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Menu,
  MenuItem,
  TextField,
  Stack,
} from "@mui/material";
import { Icon } from "@iconify/react";
import dayjs from "dayjs";
import {
  extendGoalDate,
  getAllGoals,
  singleOrBulkArchiveUnarchive,
} from "../../../redux/features/appraisalSlice";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

const ExtendDateMenu = ({ goalId, dispatchData, disabled, lastDate }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [extendDate, setExtendDate] = React.useState(
    dayjs(lastDate).add(1, "day").format("YYYY-MM-DD")
  );
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setExtendDate(dayjs(lastDate).add(1, "day").format("YYYY-MM-DD"));
  };

  const handleSubmit = () => {
    const data = { id: goalId, endDate: extendDate };
    dispatch(extendGoalDate(data)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        dispatch(getAllGoals(dispatchData));
      } else {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      }
    });
    handleClose();
  };

  return (
    <Box>
      <Button
        disabled={disabled}
        sx={{
          boxShadow: "none",
          fontSize: "0.65rem",
          borderRadius: "4px",
          "&:hover": {
            bgcolor: "primary.main",
            color: "white",
          },
        }}
        variant="outlined"
        color="primary"
        onClick={handleOpen}
        size="small"
        startIcon={
          <Icon icon="streamline:calendar-jump-to-date-solid" height={15} />
        }
      >
        Extend Date
      </Button>

      <Menu
        sx={{
          "& .MuiPaper-root": {
            marginBottom: "100px",
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        MenuListProps={{
          sx: {
            width: 300,
            p: 1,
          },
        }}
      >
        <TextField
          fullWidth
          size="small"
          label="Choose Extension Date"
          type="date"
          InputProps={{
            inputProps: {
              min: lastDate,
            },
          }}
          InputLabelProps={{ shrink: true }}
          sx={{ mt: 1, pt: 0.2 }}
          value={extendDate}
          onChange={(e) => setExtendDate(e.target.value)}
        />

        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
          sx={{ mt: 1 }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Stack>
      </Menu>
    </Box>
  );
};

export default ExtendDateMenu;
